export const GET_IMPS_REQUEST = "GET_IMPS_REQUEST"
export const GET_IMPS_SUCCESS = "GET_IMPS_SUCCESS"
export const GET_IMPS_FAILED = "GET_IMPS_FAILED"

export const EXPORT_IMPS_REQUEST = "EXPORT_IMPS_REQUEST"
export const EXPORT_IMPS_SUCCESS = "EXPORT_IMPS_SUCCESS"
export const EXPORT_IMPS_FAILED = "EXPORT_IMPS_FAILED"

export const GetImpsAction = (hour: any, searchBy:any, search:any)=>{
    return{
        type:GET_IMPS_REQUEST,payload: { hour, searchBy, search}
    }
}

export const exportCIMPDataAction = (hour: any, searchBy:any, search:any) => {
    return { 
        type: EXPORT_IMPS_REQUEST, payload: { hour, searchBy, search }
    }
}